module.exports = __webpack_public_path__ + "static/media/process_4.18387428.png";